// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sv-2";
export var chatLink = "_sv-0";
export var chatText = "_sv-1";